import { render, staticRenderFns } from "./LocsHistorialTabContent.vue?vue&type=template&id=014d3e26"
import script from "./LocsHistorialTabContent.vue?vue&type=script&lang=js"
export * from "./LocsHistorialTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports